import request from '@/utils/request'

/**
 *  订单列表
 * @param {*} data
 */
export function getOrderList(data) {
    return request({
        url: '/index/order/orderList',
        method: 'post',
        data
    })
}

/**
 *  下载报表
 * @param {*} data
 */
export function orderExport(data) {
    return request({
        url: '/index/order/orderExport',
        method: 'get',
        data
    })
}

/**
 *  影票详情
 * @param {*} data
 */
export function orderDetail(data) {
    return request({
        url: '/index/order/orderDetail',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/order.js